import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { SqlCopySource } from 'app/model/pipeline/copysource/sql.copysource';
import { SqlSink } from 'app/model/pipeline/copysink/sql.copysink';
import { SqlServerSink } from 'app/model/pipeline/copysink/sql-server.copysink';
import { SqlServerCopySource } from 'app/model/pipeline/copysource/sql-server.copysource';
import { cdcDestination, getSqlServerLinkedServiceControls, sqlAdditionalPropertiesInFabricKeyOptions } from '../consts/metadata-consts';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { IDataflowBuildInTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataflow-format-type-metadata';
import { ConnectionAuthKind } from 'shell-models-lib';
import { BuiltInDataSourceOptionId, DataSourceOptionKind } from '@powerquery/mashup-editor-client';
import { GlobalVariables } from 'app/services/globals';

const dataflowSqlServer: IDataflowBuildInTypeMetadata = {
    type: DatasetFormatType.OnPremiseSqlServer,
    settings: adfModelTypeMap.sqlServer.dataflowSettings,
    enableAlterRow: true
};

export const sqlServerMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.sqlServer.linkedServiceType,
    displayName: stringResources.SqlServer_DisplayText,
    linkedServiceKind: 'table',
    supportedInTrident: true,
    supportAutoFillCopilotInput: true,
    isKnownInPipelineContext: true,
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.BuiltIn,
        id: BuiltInDataSourceOptionId.Sql
    },
    supportedAuthKindsInTrident: [ConnectionAuthKind.Basic, ConnectionAuthKind.Windows, ConnectionAuthKind.ServicePrincipal, ConnectionAuthKind.OAuth2],
    icon: {
        className: 'svg-i-100x100-SQLServer'
    },
    distinguishTableView: true,
    queryAlias: 'sqlReaderQuery',
    isFirstClass: true,
    supportPreCopyScript: true,
    supportDataFlowSource: true,
    supportDataFlowSink: true,
    supportScriptActivity: true,
    supportStoredProcedureActivity: true,
    dataflowSource: [dataflowSqlServer],
    dataflowSink: [dataflowSqlServer],
    supportDatasetV2: true,
    tableColumnNameQuotes: ['[', ']'],
    supportGetMetadataActivity: true,
    copySinkTypes: [Metamodel.modelFor(SqlSink).name, Metamodel.modelFor(SqlServerSink).name],
    copySourceTypes: [Metamodel.modelFor(SqlCopySource).name, Metamodel.modelFor(SqlServerCopySource).name],
    category: ['Database'],
    supportFirstClassParameterExperience: true,
    supportControlTable: true,
    supportOPDG: GlobalVariables.enableOPDG,
    supportOPDGInMirror: true,
    supportVNETInMirror: true,
    supportCopyJobSource: true,
    supportCopyJobSink: true,
    copyJob: { omitConnectionDatabaseFromDataset: true },
    cdc: {
        supportCDC: true,
        supportedCDCDestinations: cdcDestination,
        tableIcon: {
            regular: 'icon-table_text_cdc_20_regular',
            filled: 'icon-table_text_cdc_20_filled'
        },
        GA: true
    },
    additionalPropertiesInFabric: GlobalVariables.connectionPropertiesForSql ? sqlAdditionalPropertiesInFabricKeyOptions : undefined,
    supportMultipleIncrementalColumns: true,
    controls: getSqlServerLinkedServiceControls(stringResources.SqlServer_DisplayText)
};
